import * as api from '../../utils/api.util';
import * as commonActions from '../actions/common.action';

// Function to get positions list
export function getPositionsList(payload = {}) {
  return async (dispatch) => {
    try {
      dispatch(commonActions.setLoading({ show: true }));
      const res = await api.ACADEMICS(payload, '/master-structural-position/list');
      dispatch(commonActions.setLoading({ show: false }));
      return res.data || [];
    } catch (err) {
      dispatch(commonActions.setLoading({ show: false }));
      throw err;
    }
  };
}

// Function to get position detail
export function getPositionDetail(id, payload = {}) {
  return async (dispatch) => {
    try {
      dispatch(commonActions.setLoading({ show: true }));
      const res = await api.ACADEMICS(payload, '/master-structural-position/get');
      dispatch(commonActions.setLoading({ show: false }));
      return res.result || null;
    } catch (err) {
      dispatch(commonActions.setLoading({ show: false }));
      throw err;
    }
  };
}

// Function to save new position
export function createPosition(payload = {}) {
  return async (dispatch) => {
    try {
      dispatch(commonActions.setLoading({ show: true }));
      const res = await api.ACADEMICS(payload, '/master-structural-position/save');
      dispatch(commonActions.setLoading({ show: false }));
      return res;
    } catch (err) {
      dispatch(commonActions.setLoading({ show: false }));
      throw err;
    }
  };
}

// Function to edit position
export function updatePosition(id, payload = {}) {
  return async (dispatch) => {
    try {
      dispatch(commonActions.setLoading({ show: true }));
      const res = await api.ACADEMICS(payload, `//master-structural-position/update/${id}`);
      dispatch(commonActions.setLoading({ show: false }));
      return res;
    } catch (err) {
      dispatch(commonActions.setLoading({ show: false }));
      throw err;
    }
  };
}

// Function to delete position
export function deletePosition(id, payload = {}) {
  return async (dispatch) => {
    try {
      dispatch(commonActions.setLoading({ show: true }));
      const res = await api.ACADEMICS(payload, `/master-structural-position/delete/${id}`);
      dispatch(commonActions.setLoading({ show: false }));
      return res;
    } catch (err) {
      dispatch(commonActions.setLoading({ show: false }));
      throw err;
    }
  };
}
